import api from 'api'
import { Campaign, CampaignDetails, CampaignTarget } from 'types/campaign'
import EnumUtils from 'utils/enum'
import VariableUtils from 'utils/variable'
import i18n from 'i18n'
import { CampaignDetailsQueryData } from 'api/campaign/types'
import { store } from '../../../../store'
import { campaignDetailsActions } from '../store/campaign-details-slice'

export default class CampaignDetailsRealizationService {
  static getData = (
    id: Campaign['id'],
    uuid: Campaign['uuid'],
    publicView: boolean | undefined
  ): void => {
    if (publicView) {
      api.campaign
        .getCampaignDetailsPublic(uuid)
        .then(
          res =>
            void CampaignDetailsRealizationService.prepareData(
              res.data.campaignReportPublic.campaignDetails
            )
        )
        .catch(() => void {})
    } else {
      api.campaign
        .getCampaignDetails(id)
        .then(res => void CampaignDetailsRealizationService.prepareData(res.data.campaignDetails))
        .catch(() => void {})
    }
  }

  static prepareData = (data: CampaignDetailsQueryData): void => {
    store.dispatch(
      campaignDetailsActions.setCampaignDetails({
        ...data,
        everUsedMedia: data.everUsedMedia.nodes,
        target:
          CampaignTarget[
            EnumUtils.getKeyByValue(CampaignTarget, data.target) as keyof typeof CampaignTarget
          ],
        currentEmissions: data.currentImpressions,
        totalEmissions: data.totalImpressions,
        totalHiddenEmissions: data.totalHiddenImpressions,
        guaranteedEmissions: data.guaranteedImpressions,
      })
    )
  }

  static parseTargetValue = (
    totalBudget: CampaignDetails['totalBudget'],
    totalEmissions: CampaignDetails['totalEmissions'] | CampaignDetails['totalHiddenEmissions'],
    budgetCurrency: Campaign['budgetCurrency'],
    totalAudience: CampaignDetails['totalAudience'] | CampaignDetails['totalHiddenAudience'],
    totalFrequency?: CampaignDetails['totalFrequency']
  ): { budget: string; emissions: string; audience: string; frequency: string } => {
    const budget = `${i18n.t('common.budget').toLocaleLowerCase()} ${VariableUtils.formatNumber(
      totalBudget
    )} ${budgetCurrency.toUpperCase()}`

    const emissions = `${VariableUtils.formatNumber(totalEmissions)} ${i18n.t(
      'common.emissions.a'
    )}`

    const audience = `${VariableUtils.formatNumber(totalAudience)} ${i18n.t('common.audience.a')}`

    const frequency = `${VariableUtils.formatNumber(totalFrequency || 0)} ${i18n.t(
      'common.frequency.a'
    )}`

    return { budget, emissions, audience, frequency }
  }
}
